import { fromCognitoIdentityPool as _fromCognitoIdentityPool, } from "@aws-sdk/credential-provider-cognito-identity";
export const fromCognitoIdentityPool = (options) => _fromCognitoIdentityPool({
    ...options,
});
